const key = (organizationId: string) => `ifrsReport.unticked.${organizationId}`;

export const rememberedUnticked = (organizationId: string): Set<string> => {
  try {
    const stored = JSON.parse(localStorage.getItem(key(organizationId)) ?? "[]");
    return new Set(Array.isArray(stored) ? stored.filter((id): id is string => typeof id === "string") : []);
  } catch {
    return new Set();
  }
};

export const rememberUnticked = (organizationId: string, contractIds: string[]) => {
  try {
    localStorage.setItem(key(organizationId), JSON.stringify(contractIds));
  } catch {
    return;
  }
};
